import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/base/SectionTitle';
import { getFeatured } from '@/utils/media';
import { typeLabel } from '@/utils/media';

export default function FeaturedSection() {
  const { t } = useTranslation();
  const featured = getFeatured();
  const [lead, ...rest] = featured;

  if (!lead) return null;

  return (
    <section className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
      <SectionTitle icon="ri-bookmark-3-line" title={t('featured')} desc={t('featuredDesc')} />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.4fr_1fr] lg:gap-5">
        <Link
          to={`/detail/${lead.id}`}
          className="group relative h-72 overflow-hidden rounded-lg md:h-[420px] cursor-pointer"
        >
          <img
            src={lead.banner}
            alt={`${lead.title}精选`}
            title={`${lead.title} ${typeLabel(lead.type)} 编辑精选`}
            className="absolute inset-0 w-full h-full object-cover object-top transition duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/45 to-transparent"></div>
          <div className="relative z-10 flex h-full flex-col justify-end p-5 md:p-7">
            <span className="mb-2 inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-accent-950">
              <i className="ri-award-line"></i>
              {t('featured')}
            </span>
            <h3 className="font-heading text-2xl font-extrabold text-background-50 md:text-3xl">{lead.title}</h3>
            <p className="mt-2 max-w-lg text-sm text-background-100/80 line-clamp-2">{lead.tagline}</p>
            <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-background-100/80">
              <span className="flex items-center gap-1 rounded-full bg-background-50/10 px-2.5 py-1 backdrop-blur">
                <i className="ri-star-fill text-accent-400"></i>
                {lead.rating.toFixed(1)}
              </span>
              <span className="rounded-full bg-background-50/10 px-2.5 py-1 backdrop-blur">{typeLabel(lead.type)}</span>
              <span className="rounded-full bg-background-50/10 px-2.5 py-1 backdrop-blur">{lead.genres.join(' · ')}</span>
            </div>
          </div>
        </Link>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1 lg:gap-5">
          {rest.slice(0, 3).map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex items-stretch gap-3 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-2 transition hover:-translate-y-0.5 hover:border-accent-300 cursor-pointer"
            >
              <div className="relative h-24 w-20 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-24">
                <img
                  src={item.cover}
                  alt={`${item.title}封面`}
                  title={`${item.title} ${typeLabel(item.type)} 推荐`}
                  className="w-full h-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col justify-center gap-1 pr-2">
                <div className="flex items-center gap-2">
                  <h4 className="line-clamp-1 font-heading text-base font-semibold text-foreground-950 group-hover:text-accent-600 transition">
                    {item.title}
                  </h4>
                </div>
                <p className="line-clamp-2 text-xs text-foreground-500">{item.tagline}</p>
                <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-star-fill text-[11px]"></i>
                    {item.rating.toFixed(1)}
                  </span>
                  <span>{typeLabel(item.type)}</span>
                  <span>{item.year}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}